import ClearIcon from '@mui/icons-material/Clear';

const FalseIcon: any = () => (
  <ClearIcon color="error"/>
);

export default FalseIcon;
